module.exports = __webpack_public_path__ + "img/diploma-patent.3d013083.svg";